module.exports = __webpack_public_path__ + "img/FjjuElx_CExU-OkauPUnatCQ1PRM.fc2a7a3e.png";